export default __webpack_public_path__ + "static/media/Group 449.59304307.png";